import apiClient from "../../../utils/interceptor";
import {
  ApiResponse,
  getCropConfigDetailsByCropIdResponse,
  CropConfig,
  UpdateCropConfigParams,
  CreateCropConfigParams,
} from './interface';
import { API_URLS } from '../../../constants';

// Helper to get auth token
const getAuthToken = (): string | null => {
  return localStorage.getItem('auth_token');
};

// Fetch crop config details by crop ID
export const getCropConfigDetailsByCropId = async (
  crop_id: string
): Promise<ApiResponse<getCropConfigDetailsByCropIdResponse[]>> => {
  try {
    const response = await apiClient.get<ApiResponse<getCropConfigDetailsByCropIdResponse[]>>(
      `${API_URLS.CROP_CONFIG.GET_CROP_CONFIG_DETAILS_BY_CROP_ID}/${crop_id}`,
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching crop config details by crop ID:', error);
    throw error;
  }
};

// Create crop configuration
export const createCropConfig = async (
  data: CreateCropConfigParams
): Promise<ApiResponse<CropConfig>> => {
  try {
    const response = await apiClient.post<ApiResponse<CropConfig>>(
      API_URLS.CROP_CONFIG.CREATE_CROP_CONFIG,
      data,
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error creating crop configuration:', error);
    throw error;
  }
};

// Fetch crop config by ID
export const getCropConfigById = async (
  id: string
): Promise<ApiResponse<CropConfig>> => {
  try {
    const response = await apiClient.get<ApiResponse<CropConfig>>(
      `${API_URLS.CROP_CONFIG.GET_CROP_CONFIG_BY_ID}/${id}`,
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching crop configuration:', error);
    throw error;
  }
};

// Update crop config by ID
export const updateCropConfigById = async (
  data: UpdateCropConfigParams
): Promise<ApiResponse<CropConfig>> => {
  try {
    const response = await apiClient.patch<ApiResponse<CropConfig>>(
      `${API_URLS.CROP_CONFIG.UPDATE_CROP_CONFIG}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating crop configuration:', error);
    throw error;
  }
};

// Delete crop config
export const deleteCropConfig = async (
  crop_config_id: string
): Promise<ApiResponse<null>> => {
  try {
    const response = await apiClient.delete<ApiResponse<null>>(
      `${API_URLS.CROP_CONFIG.DELETE_CROP_CONFIG}`,
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
        data: { crop_config_id: crop_config_id },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error deleting crop configuration:', error);
    throw error;
  }
};
